export enum KycStatus {
    INCOMPLETE = 'INCOMPLETE',
    INITIATED = 'INITIATED',
    SUBMITTED = 'SUBMITTED',
    PASS = 'PASS',
    FAIL = 'FAIL',
    ERROR = 'ERROR',
}
